import { useDispatch, useSelector } from 'react-redux';

// Typed hooks for better TypeScript support (if you migrate later)
// For now, these are just re-exports but can be extended with types

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

